import { render, staticRenderFns } from "./GoogleReviews.vue?vue&type=template&id=5a6a686c&scoped=true&"
import script from "./GoogleReviews.vue?vue&type=script&lang=ts&"
export * from "./GoogleReviews.vue?vue&type=script&lang=ts&"
import style0 from "./GoogleReviews.vue?vue&type=style&index=0&id=5a6a686c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a686c",
  null
  
)

export default component.exports